import { FixedSizeList, ListChildComponentProps } from 'react-window';
import { Recipe } from '../../store/Recipe';
import RecipeListItem from './RecipeListItem';

function renderRow(props: ListChildComponentProps) {
  const { index, style, data } = props;
  const recipe = data[index]

  return (
    <RecipeListItem
      recipe={recipe}
      index={index}
      style={style}
    />
  );
}

interface RecipeListData {
  index: Recipe[]
}

export default function RecipeList(props: RecipeListData) {

  return (
    <FixedSizeList
      height={525}
      width={"100%"}
      itemSize={60}
      itemCount={props.index.length}
      itemData={props.index}
      overscanCount={5}
    >
      {renderRow}
    </FixedSizeList>
  );
}